import { FC } from 'react';
import { Box, Button, IconButton, Tooltip, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

interface HouseholdCompositionToolbarProps {
  onAddMember: () => void;
  onHelp?: () => void;
  canManage?: boolean;
  memberCount?: number;
}

const HouseholdCompositionToolbar: FC<HouseholdCompositionToolbarProps> = ({
  onAddMember,
  onHelp,
  canManage = true,
  memberCount,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        mb: 2,
      }}
    >
      {memberCount != null && (
        <Typography variant="body2" fontWeight={700} color="text.primary">
          {memberCount} {memberCount === 1 ? 'Member' : 'Members'}
        </Typography>
      )}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, ml: 'auto' }}>
        {canManage && (
          <Button
            variant="contained"
            color="info"
            startIcon={<AddIcon />}
            onClick={onAddMember}
            size="small"
          >
            <span>Add Member</span>
          </Button>
        )}
        {onHelp && (
          <Tooltip
            title="Click to see information about household composition"
            placement="right"
            arrow
            slotProps={{ tooltip: { sx: { maxWidth: 400, p: 2 } } }}
          >
            <IconButton onClick={onHelp} size="small">
              <HelpOutlineIcon sx={{ color: 'text.secondary', fontSize: 20 }} />
            </IconButton>
          </Tooltip>
        )}
      </Box>
    </Box>
  );
};

export default HouseholdCompositionToolbar;
